import { render, staticRenderFns } from "./WatchButton.vue?vue&type=template&id=581503f5&"
import script from "./WatchButton.vue?vue&type=script&lang=js&"
export * from "./WatchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports